"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Token = void 0;
require("./types");
class Token {
    constructor(accessTokenStorage, refreshTokenStorage, tokenCreator, tokenRefresher, options = {}) {
        this.accessTokenStorage = accessTokenStorage;
        this.refreshTokenStorage = refreshTokenStorage;
        this.tokenCreator = tokenCreator;
        this.tokenRefresher = tokenRefresher;
        this.options = options;
        this.accessTokenStorage = accessTokenStorage;
        this.refreshTokenStorage = refreshTokenStorage;
        this.tokenCreator = tokenCreator;
        this.tokenRefresher = tokenRefresher;
        this.options = options;
    }
    getToken() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.accessTokenStorage.getToken();
        });
    }
    setToken(value) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.accessTokenStorage.setToken(value);
        });
    }
    createToken({ username, password, code, token, options, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const { accessToken, refreshToken, mfaToken, error } = yield this.tokenCreator({
                username,
                password,
                code,
                token,
                options,
            });
            if (error) {
                return {
                    ok: false,
                    error,
                };
            }
            if (accessToken) {
                yield this.accessTokenStorage.setToken(accessToken);
            }
            if (refreshToken) {
                yield this.refreshTokenStorage.setToken(refreshToken);
            }
            return Object.assign(Object.assign({}, options), { ok: true, isMfa: !!mfaToken, accessToken,
                refreshToken,
                mfaToken });
        });
    }
    hasToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const token = yield this.getToken();
            return !!token;
        });
    }
    refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            const [accessTokenOld, refreshTokenOld] = yield Promise.all([
                this.accessTokenStorage.getToken(),
                this.refreshTokenStorage.getToken(),
            ]);
            const { accessToken, refreshToken } = yield this.tokenRefresher({
                options: this.options,
                accessToken: accessTokenOld,
                refreshToken: refreshTokenOld,
            });
            yield Promise.all([
                accessToken ? this.accessTokenStorage.setToken(accessToken) : Promise.resolve(null),
                refreshToken ? this.refreshTokenStorage.setToken(refreshToken) : Promise.resolve(null),
            ]);
        });
    }
    clear() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all([
                this.accessTokenStorage.setToken(''),
                this.refreshTokenStorage.setToken(''),
            ]);
        });
    }
}
exports.Token = Token;
//# sourceMappingURL=Token.js.map